import ax, { InternalAxiosRequestConfig } from "axios";
import { Auth } from 'aws-amplify';

let BASE_URL = 'http://localhost:8000/api/v1/';
if (process.env.REACT_APP_ENVIRONMENT === 'develop' || process.env.REACT_APP_ENVIRONMENT === 'production') {
  BASE_URL = "https://realtime-fld.gaia-vision.co.jp/api/v1/"
} else if (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'production'){
  BASE_URL = "https://water-vision-api.gaia-vision.co.jp/api/v1/"
}

const instance = ax.create({
  baseURL: BASE_URL,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(async (config:InternalAxiosRequestConfig & { token?: string }& { headers?: any }) => {
  if (config.token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${config.token}`,
    }
  }

  return config;
}, (err) => Promise.reject(err));

instance.interceptors.response.use(async response => {
  // console.log(`response ${response.config.method} ${response.config.url}: `, data);
  return response;
}, (err: any) => {
  console.log(`error ${err.config.method} ${err.config.url}: `, err);
  if (err.response.data && err.response.data.description) {
    alert(err.response.data.description);
  }
  return Promise.reject(err);
});

const OPTIONS_DEF = { data: {}, isToken: true };

const getToken = async () => {
  try {
    const userAuthed = await Auth.currentAuthenticatedUser();
    return userAuthed.signInUserSession.idToken.jwtToken;
  } catch (error) {
    return null;
  }
}

export const axiosWithToken = {
  get: async (url: string, options = OPTIONS_DEF) => {
    const token = options.isToken ? await getToken() : null;
    return await instance.get(url, { headers: { Authorization: `Bearer ${token}` } });
  },

  post: async (url: string, options = OPTIONS_DEF) => {
    const token = options.isToken ? await getToken() : null;
    const dataToSend = Array.isArray(options.data) ? options.data : { ...options.data };

    return await instance.post(url, dataToSend, { headers: { Authorization: `Bearer ${token}` } });
  },

  patch: async (url: string, options = OPTIONS_DEF) => {
    const token = options.isToken ? await getToken() : null;

    return await instance.patch(url, { ...options.data || {} }, { headers: { Authorization: `Bearer ${token}` } });
  },

  put: async (url: string, options = OPTIONS_DEF) => {
    const token = options.isToken ? await getToken() : null;

    return await instance.put(url, { ...options.data || {} }, { headers: { Authorization: `Bearer ${token}` } });
  },

  delete: async (url: string, options = OPTIONS_DEF) => {
    const token = options.isToken ? await getToken() : null;
    return await instance.delete(url, { headers: { Authorization: `Bearer ${token}` } });
  },
}